import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  throwInvalidFloatingPointDecoded3ghwdo6vya1kj as throwInvalidFloatingPointDecoded,
} from './JsonExceptions.mjs';
import {
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
} from './JsonNamesMap.mjs';
import { ENUM_getInstance1f3d4zr61j5rk as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { JsonTreeReader1ycreu77eikqj as JsonTreeReader } from './JsonTreeReader.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from '../JsonExceptions.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { readPolymorphicJson7wfdzotvo8aj as readPolymorphicJson } from './TreeJsonDecoder.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { missingFieldExceptionWithNewMessage2gqddjx5jxge9 as missingFieldExceptionWithNewMessage } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import {
  switchMode35g725ikhjpwv as switchMode,
  WriteMode_MAP_getInstance2u4in6emm7r2a as WriteMode_MAP_getInstance,
} from './WriteMode.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  fromInt2ii0rejb1w62w as fromInt,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import {
  toUInt21lx0mz8wkp7c as toUInt,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  toUShort7yqspfnhrot4 as toUShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _UInt___get_data__impl__f0vqqw18g8a2o14g87q as _UInt___get_data__impl__f0vqqw } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { _ULong___get_data__impl__fggpzb35t7vg7og3i8u as _ULong___get_data__impl__fggpzb } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { _UShort___get_data__impl__g02451joe1vsk2vach as _UShort___get_data__impl__g0245 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DiscriminatorHolderClass;
function DiscriminatorHolder() {
  if (DiscriminatorHolderClass === VOID) {
    class $ {
      constructor(discriminatorToSkip) {
        this.l2t_1 = discriminatorToSkip;
      }
    }
    initMetadataForClass($, 'DiscriminatorHolder');
    DiscriminatorHolderClass = $;
  }
  return DiscriminatorHolderClass;
}
function trySkip($this, $receiver, unknownKey) {
  if ($receiver == null)
    return false;
  if ($receiver.l2t_1 === unknownKey) {
    $receiver.l2t_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.o1r(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.z2l_1.c2t() === 4) {
    $this.z2l_1.w2r('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.b2m_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.b2m_1 === -1)) {
      hasComma = $this.z2l_1.n2t();
    }
  } else {
    $this.z2l_1.m2t(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.z2l_1.d2t()) {
    if (decodingKey) {
      if ($this.b2m_1 === -1) {
        var tmp0 = $this.z2l_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.g2m_1;
        if (!condition) {
          var tmp$ret$1 = 'Unexpected leading comma';
          tmp0.w2r(tmp$ret$1, position);
        }
      } else {
        var tmp0_0 = $this.z2l_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.g2m_1;
        if (!condition_0) {
          var tmp$ret$3 = 'Expected comma after the key-value pair';
          tmp0_0.w2r(tmp$ret$3, position_0);
        }
      }
    }
    $this.b2m_1 = $this.b2m_1 + 1 | 0;
    tmp = $this.b2m_1;
  } else {
    if (hasComma && !$this.x2l_1.s2l_1.t2n_1) {
      invalidTrailingComma($this.z2l_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.x2l_1;
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.k1p(index);
    var elementDescriptor = descriptor.j1p(index);
    var tmp;
    if (isOptional && !elementDescriptor.v1o()) {
      tmp = $this.z2l_1.o2t(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.c1p(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.v1o()) {
        tmp_0 = $this.z2l_1.o2t(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.z2l_1.p2t($this.d2m_1.h2n_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.s2l_1.k2n_1 && elementDescriptor.v1o();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.z2l_1.e2t();
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.z2l_1.n2t();
  while ($this.z2l_1.d2t()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.z2l_1.m2t(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.x2l_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.d2m_1.m2n_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.z2l_1.n2t();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.e2m_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.t2r(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.x2l_1.s2l_1.t2n_1) {
    invalidTrailingComma($this.z2l_1);
  }
  var tmp1_safe_receiver = $this.e2m_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u2r();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.x2l_1) || trySkip($this, $this.c2m_1, key)) {
    $this.z2l_1.r2t($this.d2m_1.h2n_1);
  } else {
    $this.z2l_1.h2m_1.j2s();
    $this.z2l_1.q2t(key);
  }
  return $this.z2l_1.n2t();
}
function decodeListIndex($this) {
  var hasComma = $this.z2l_1.n2t();
  var tmp;
  if ($this.z2l_1.d2t()) {
    if (!($this.b2m_1 === -1) && !hasComma) {
      $this.z2l_1.w2r('Expected end of the array or comma');
    }
    $this.b2m_1 = $this.b2m_1 + 1 | 0;
    tmp = $this.b2m_1;
  } else {
    if (hasComma && !$this.x2l_1.s2l_1.t2n_1) {
      invalidTrailingComma($this.z2l_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.d2m_1.h2n_1) {
    tmp = $this.z2l_1.t2t();
  } else {
    tmp = $this.z2l_1.s2t();
  }
  return tmp;
}
var StreamingJsonDecoderClass;
function StreamingJsonDecoder() {
  if (StreamingJsonDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(json, mode, lexer, descriptor, discriminatorHolder) {
        super();
        this.x2l_1 = json;
        this.y2l_1 = mode;
        this.z2l_1 = lexer;
        this.a2m_1 = this.x2l_1.m1r();
        this.b2m_1 = -1;
        this.c2m_1 = discriminatorHolder;
        this.d2m_1 = this.x2l_1.s2l_1;
        this.e2m_1 = this.d2m_1.k2n_1 ? null : new (JsonElementMarker())(descriptor);
      }
      x2n() {
        return this.x2l_1;
      }
      m1r() {
        return this.a2m_1;
      }
      y2n() {
        return (new (JsonTreeReader())(this.x2l_1.s2l_1, this.z2l_1)).g2t();
      }
      w1q(deserializer) {
        try {
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.x2l_1.s2l_1.n2n_1;
          }
          if (tmp) {
            return deserializer.i1m(this);
          }
          var discriminator = classDiscriminator(deserializer.g1m(), this.x2l_1);
          var tmp0_elvis_lhs = this.z2l_1.u2t(discriminator, this.d2m_1.h2n_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp2 = isInterface(deserializer, DeserializationStrategy()) ? deserializer : THROW_CCE();
            var tmp$ret$0;
            $l$block: {
              // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
              var tmp_1;
              if (!(tmp2 instanceof AbstractPolymorphicSerializer())) {
                tmp_1 = true;
              } else {
                tmp_1 = this.x2n().s2l_1.n2n_1;
              }
              if (tmp_1) {
                tmp$ret$0 = tmp2.i1m(this);
                break $l$block;
              }
              var discriminator_0 = classDiscriminator(tmp2.g1m(), this.x2n());
              var tmp2_0 = this.y2n();
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName = tmp2.g1m().j1n();
              if (!(tmp2_0 instanceof JsonObject())) {
                var tmp2_1 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2_0).j1() + ' as the serialized body of ' + serialName;
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path = this.z2l_1.h2m_1.k2s();
                var tmp_2;
                if (this.x2n().s2l_1.w2n_1) {
                  var tmp$ret$6 = toString(tmp2_0);
                  tmp_2 = toString(minify(tmp$ret$6));
                } else {
                  tmp_2 = null;
                }
                var inputValue = tmp_2;
                throw JsonDecodingException().k2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path, null, inputValue), tmp2_1, -1, path, inputValue, null);
              }
              var jsonTree = tmp2_0;
              var tmp0_safe_receiver = jsonTree.c2o(discriminator_0);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
              var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
              var tmp_3;
              try {
                tmp_3 = findPolymorphicSerializer(tmp2, this, type);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof SerializationException()) {
                  var it = $p;
                  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                  var shortMessage = ensureNotNull(it.message);
                  var tmp_5;
                  if (this.x2n().s2l_1.w2n_1) {
                    var tmp$ret$10 = jsonTree.toString();
                    tmp_5 = toString(minify(tmp$ret$10));
                  } else {
                    tmp_5 = null;
                  }
                  var inputValue_0 = tmp_5;
                  throw JsonDecodingException().k2p(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue_0), shortMessage, -1, null, inputValue_0, null);
                } else {
                  throw $p;
                }
              }
              var tmp_6 = tmp_3;
              var actualSerializer = isInterface(tmp_6, DeserializationStrategy()) ? tmp_6 : THROW_CCE();
              tmp$ret$0 = readPolymorphicJson(this.x2n(), discriminator_0, jsonTree, actualSerializer);
            }
            return tmp$ret$0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var type_0 = tmp_0;
          var tmp_7;
          try {
            tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
          } catch ($p_0) {
            var tmp_8;
            if ($p_0 instanceof SerializationException()) {
              var it_0 = $p_0;
              var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
              var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
              this.z2l_1.w2r(message, VOID, hint);
            } else {
              throw $p_0;
            }
            tmp_7 = tmp_8;
          }
          var tmp_9 = tmp_7;
          var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy()) ? tmp_9 : THROW_CCE();
          this.c2m_1 = new (DiscriminatorHolder())(discriminator);
          return actualSerializer_0.i1m(this);
        } catch ($p_1) {
          if ($p_1 instanceof MissingFieldException()) {
            var e = $p_1;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            throw missingFieldExceptionWithNewMessage(e, plus(e.message, ' at path: ') + this.z2l_1.h2m_1.k2s());
          } else {
            throw $p_1;
          }
        }
      }
      x1q(descriptor) {
        var newMode = switchMode(this.x2l_1, descriptor);
        this.z2l_1.h2m_1.f2s(descriptor);
        this.z2l_1.m2t(newMode.x2t_1);
        checkLeadingComma(this);
        var tmp;
        switch (newMode.w1_1) {
          case 1:
          case 2:
          case 3:
            tmp = new (StreamingJsonDecoder())(this.x2l_1, newMode, this.z2l_1, descriptor, this.c2m_1);
            break;
          default:
            var tmp_0;
            if (this.y2l_1.equals(newMode) && this.x2l_1.s2l_1.k2n_1) {
              tmp_0 = this;
            } else {
              tmp_0 = new (StreamingJsonDecoder())(this.x2l_1, newMode, this.z2l_1, descriptor, this.c2m_1);
            }

            tmp = tmp_0;
            break;
        }
        return tmp;
      }
      y1q(descriptor) {
        if (descriptor.e1p() === 0 && ignoreUnknownKeys(descriptor, this.x2l_1)) {
          skipLeftoverElements(this, descriptor);
        }
        if (this.z2l_1.n2t() && !this.x2l_1.s2l_1.t2n_1) {
          invalidTrailingComma(this.z2l_1, '');
        }
        this.z2l_1.m2t(this.y2l_1.y2t_1);
        this.z2l_1.h2m_1.j2s();
      }
      i1q() {
        var tmp;
        var tmp0_safe_receiver = this.e2m_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s2r_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = !this.z2l_1.z2t();
        } else {
          tmp = false;
        }
        return tmp;
      }
      j1q() {
        return null;
      }
      j1r(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.y2l_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) {
          this.z2l_1.h2m_1.i2s();
        }
        var value = super.j1r(descriptor, index, deserializer, previousValue);
        if (isMapKey) {
          this.z2l_1.h2m_1.h2s(value);
        }
        return value;
      }
      o1r(descriptor) {
        var index;
        switch (this.y2l_1.w1_1) {
          case 0:
            index = decodeObjectIndex(this, descriptor);
            break;
          case 2:
            index = decodeMapIndex(this);
            break;
          default:
            index = decodeListIndex(this);
            break;
        }
        if (!this.y2l_1.equals(WriteMode_MAP_getInstance())) {
          this.z2l_1.h2m_1.g2s(index);
        }
        return index;
      }
      k1q() {
        return this.z2l_1.a2u();
      }
      l1q() {
        var value = this.z2l_1.b2u();
        if (!(value === fromInt(convertToByte(value)))) {
          this.z2l_1.w2r("Failed to parse byte for input '" + value.toString() + "'");
        }
        return convertToByte(value);
      }
      m1q() {
        var value = this.z2l_1.b2u();
        if (!(value === fromInt(convertToShort(value)))) {
          this.z2l_1.w2r("Failed to parse short for input '" + value.toString() + "'");
        }
        return convertToShort(value);
      }
      n1q() {
        var value = this.z2l_1.b2u();
        if (!(value === fromInt(convertToInt(value)))) {
          this.z2l_1.w2r("Failed to parse int for input '" + value.toString() + "'");
        }
        return convertToInt(value);
      }
      o1q() {
        return this.z2l_1.b2u();
      }
      p1q() {
        var tmp0 = this.z2l_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.f2t();
          try {
            // Inline function 'kotlin.text.toFloat' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.w2r("Failed to parse type '" + 'float' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.x2l_1.s2l_1.p2n_1;
        if (specialFp || isFinite(result))
          return result;
        throwInvalidFloatingPointDecoded(this.z2l_1, result);
      }
      q1q() {
        var tmp0 = this.z2l_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.f2t();
          try {
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.w2r("Failed to parse type '" + 'double' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.x2l_1.s2l_1.p2n_1;
        if (specialFp || isFinite_0(result))
          return result;
        throwInvalidFloatingPointDecoded(this.z2l_1, result);
      }
      r1q() {
        var string = this.z2l_1.f2t();
        if (!(string.length === 1)) {
          this.z2l_1.w2r("Expected single char, but got '" + string + "'");
        }
        return charCodeAt(string, 0);
      }
      s1q() {
        var tmp;
        if (this.d2m_1.h2n_1) {
          tmp = this.z2l_1.t2t();
        } else {
          tmp = this.z2l_1.e2t();
        }
        return tmp;
      }
      u1q(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new (JsonDecoderForUnsignedTypes())(this.z2l_1, this.x2l_1) : super.u1q(descriptor);
      }
      t1q(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.x2l_1, this.s1q(), ' at path ' + this.z2l_1.h2m_1.k2s());
      }
    }
    initMetadataForClass($, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder()]);
    StreamingJsonDecoderClass = $;
  }
  return StreamingJsonDecoderClass;
}
var JsonDecoderForUnsignedTypesClass;
function JsonDecoderForUnsignedTypes() {
  if (JsonDecoderForUnsignedTypesClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(lexer, json) {
        super();
        this.c2u_1 = lexer;
        this.d2u_1 = json.m1r();
      }
      m1r() {
        return this.d2u_1;
      }
      o1r(descriptor) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
      n1q() {
        var tmp0 = this.c2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.f2t();
          try {
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = toUInt(input);
            tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.w2r("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      o1q() {
        var tmp0 = this.c2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.f2t();
          try {
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = toULong(input);
            tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.w2r("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      l1q() {
        var tmp0 = this.c2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.f2t();
          try {
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = toUByte(input);
            tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.w2r("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      m1q() {
        var tmp0 = this.c2u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.f2t();
          try {
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = toUShort(input);
            tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.w2r("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'JsonDecoderForUnsignedTypes');
    JsonDecoderForUnsignedTypesClass = $;
  }
  return JsonDecoderForUnsignedTypesClass;
}
//region block: exports
export {
  JsonDecoderForUnsignedTypes as JsonDecoderForUnsignedTypesaowwj2t4rf8t,
  StreamingJsonDecoder as StreamingJsonDecoderyo05rsghf9i6,
};
//endregion

//# sourceMappingURL=StreamingJsonDecoder.mjs.map
